// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { AnalisiBilancioDto } from '@ideapa/common-dto';
import { ImportiAnalisiBilancio } from '@ideapa/common-utils';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class AnalisiBilancioApiClient extends BaseCRUDApiClient<AnalisiBilancioDto> {
  baseUrl = this.config.apiEndpoint + '/analisi-bilancio';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  getRigheAnalisiBilancio(idPartecipata: number) {
    return this.http.get<ImportiAnalisiBilancio[]>(
      `${this.baseUrl}/id-partecipata/${idPartecipata}`
    );
  }
}
